var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('ik-data-table',{ref:"table",attrs:{"model":_vm.model,"entity-name":"BusinessLayer","icon":"mdi-cash-usd"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }